"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.scaleIngredient = void 0;
const units_1 = require("../../units");
const fractionize_1 = require("../fractionize");
const parseStringAmount_1 = require("./parseStringAmount");
const spacedRegex = /(\d+)\s+(\d.*)/;
exports.scaleIngredient = (ingredient, scale) => {
    if ("amount" in ingredient &&
        ingredient.amount !== null &&
        ingredient.amount !== undefined) {
        try {
            const [amount, amount2] = parseStringAmount_1.parseStringAmount(ingredient.amount);
            if (amount2) {
                return Object.assign(Object.assign({}, ingredient), { amount: `${amount * scale}-${amount2 * scale}`, scaled: true });
            }
            if (!amount) {
                const match = ingredient.amount.match(spacedRegex);
                if (match) {
                    const [, s1, s2] = match;
                    const n1 = parseInt(s1);
                    if (!isNaN(n1)) {
                        return Object.assign(Object.assign({}, ingredient), { amount: `${n1 * scale} ${s2}`, scaled: true });
                    }
                }
                return Object.assign(Object.assign({}, ingredient), { scaled: false });
            }
            return Object.assign(Object.assign({}, ingredient), { amount: !ingredient.unit || !units_1.isMetric(ingredient.unit.toLowerCase())
                    ? fractionize_1.fractionize(amount * scale, true)
                    : `${amount * scale}`, scaled: true });
        }
        catch (_a) { }
    }
    return Object.assign(Object.assign({}, ingredient), { scaled: false });
};
//# sourceMappingURL=index.js.map